module.exports = __webpack_public_path__ + "img/fruit-asian-pears-350x184.ef1a3362.jpg";